module.exports = __webpack_public_path__ + "static/media/icon.cef5a4bc.svg";